import React from 'react';
import './NavBarItem.scss';
import { Link, useLocation } from 'react-router-dom';
import { useDataLayerValue } from '../../../DataLayer';



function NavBarItemHome(props) {
    const [{ lang }] = useDataLayerValue();
    const localtion = useLocation();
    return (
        <div className={`nav-bar-item ${localtion.pathname === '/' ? 'active-link' : ''}`}>
            <Link to="/" className="link-subtle" draggable="false" aria-current="page">
                {localtion.pathname === '/' ?
                    (<div className="icon active-icon">
                        <svg viewBox="0 0 512 512" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M448 463.746h-149.333v-149.333h-85.334v149.333h-149.333v-315.428l192-111.746 192 110.984v316.19z" fill="currentColor"></path>
                        </svg>
                    </div>) : (<div className="icon ">
                        <svg viewBox="0 0 512 512" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M 256.274 60.84 L 84.324 166.237 L 84.324 443.063 L 193.27 443.063 L 193.27 293.73 L 320.228 293.73 L 320.228 443.063 L 428.222 443.063 L 428.222 165.476 L 256.274 60.84 Z M 256.274 35.95 L 448.452 149.145 L 448.452 464.395 L 300 464.395 L 300 315.062 L 213.499 315.062 L 213.499 464.395 L 64.095 464.395 L 64.095 150.161 L 256.274 35.95 Z" fill="currentColor"></path>
                        </svg>
                    </div>)}
                <span className="ellipsis-one-line" as="span">{lang === 'en' ? 'Home' : 'Trang chủ'}</span>
            </Link>
        </div>
    );
}

export default NavBarItemHome;